import { useLazyQuery, useQuery } from '@apollo/client';
import classNames from 'classnames';
import { get } from 'lodash';
import { FC, useMemo } from 'react';
import Container from '~/components/Container';
import {
    QUERY_RELATED_PRODUCT_BY_CART,
    QUERY_TRACK_VIEW_COLLECTION,
    QUERY_TRACK_VIEW_ITEM_RELATED,
    QUERY_TRACKING_VIEW_RELATED
} from '~/data/product/gql';
import { transformProductItems } from '~/utils/transform';

import { Product } from '~/services/product';
import ProductsSlider from '~/components/ProductsSlider';

interface ProductsRelatedProps {
    title?: string;
    className?: string;
    cartId: string;
    ruleId: number;
    limit?: number;
}

const ProductsRelated: FC<ProductsRelatedProps> = ({ title, className, cartId, ruleId, limit }) => {
    const { data, loading, called } = useQuery(QUERY_RELATED_PRODUCT_BY_CART, {
        variables: {
            cartId,
            ruleId,
            limit: limit || 15
        },
        skip: !cartId || !ruleId,
        context: { fetchOptions: { method: 'GET' } }
    });

    const [queryTrackingViewList] = useLazyQuery(QUERY_TRACKING_VIEW_RELATED);
    const [queryTrackingViewCollection] = useLazyQuery(QUERY_TRACK_VIEW_COLLECTION);

    const [queryTrackViewItemReleated] = useLazyQuery(QUERY_TRACK_VIEW_ITEM_RELATED);

    const productList = useMemo(() => transformProductItems(get(data, 'relatedProductsByCart.items', [])), [data]);

    return (
        <Container className={classNames('flex flex-col gap-6 pt-5', className)}>
            {/* <SectionTitle text={title || data?.relatedProduct?.name} /> */}
            <ProductsSlider
                listkey={ruleId as any}
                loading={loading}
                loop={false}
                title={title || get(data, 'relatedProductsByCart.name', '')}
                products={productList}
                onEnter={() => {
                    queryTrackingViewList({
                        variables: {
                            block_id: ruleId
                        }
                    });
                    queryTrackingViewCollection({
                        variables: {
                            block_id: ruleId,
                            type: 'related'
                        }
                    });
                }}
                onImpressions={(products: Array<Partial<Product>>) => {
                    queryTrackViewItemReleated({
                        variables: {
                            block_id: ruleId,
                            skus: products?.map((prod) => prod?.sku)
                        }
                    });
                }}
            />
        </Container>
    );
};

export default ProductsRelated;
